export const checkInvalidItensTable = (array: any[]): boolean => {
  return array.every(
    (item) =>
      item.qtdStatusBloq !== 0 &&
      item.qtdStatusNe !== 0 &&
      item.qtdStatusMix !== 0 &&
      item.qtdStatusInf !== 0,
  );
};
